import { COLLECTIONS } from "constants/action-types";
import { FluxStandardAction as Action } from "flux-standard-action";

// Match Size Ranges with Selected Sizes
export interface IMatchSelectedSizesWithSizeRangesPayload {
    collectionId: string;
    itemIds: string[];
    filterByBrand: string;
}

export type MatchSelectedSizesWithSizeRangesAction = Action<IMatchSelectedSizesWithSizeRangesPayload, {}>;

export interface IMatchSelectedSizesWithSizeRangesMatchedPayload {
    collectionId: string;
    itemId: string;
    error?: string;
    selectedSizes?: string;
    sizeRange?: ISizeRange;
}

export type MatchSelectedSizesWithSizeRangesMatchedAction = Action<IMatchSelectedSizesWithSizeRangesMatchedPayload, {}>;

export const matchSelectedSizesWithSizeRangesMatched = (
    payload: IMatchSelectedSizesWithSizeRangesMatchedPayload,
): MatchSelectedSizesWithSizeRangesMatchedAction => ({
    meta: {},
    payload,
    type: COLLECTIONS.COLLECTION.SIZING.SIZE_RANGES.MATCH.MATCHED,
});

export interface ISetSizeRangeLabelPayload {
    sizeRangeLabel: string;
    itemId: string;
}

export type SetSizeRangeLabelAction = Action<ISetSizeRangeLabelPayload, {}>;

export interface ISizeRange {
    label: string;
    sizes: string[];
}

export interface ISizeRangesPayload {
    items?: ISizeRange[];
    error?: string;
}

export type FetchSizeRangesCompletedAction = Action<ISizeRangesPayload, {}>;

export interface IStartSyncSelectedSizesPayload {
    collectionId: string;
    override?: boolean;
}
export type StartSyncSelectedSizesAction = Action<IStartSyncSelectedSizesPayload, {}>;
